import Button from 'atoms/Button';
import 'dayjs/locale/pl';
import Container from 'layout/atoms/Container';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SubscriptionPage = () => {
    const query = useQuery();
    const sessionId = query.get('sessionId');
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Container size="s">
            <>
                <br />
                <br />
                {t('SUBSCRIPTION.PAYMENT_SUCCESSFUL')}
                <br />
                <br />
                <Button
                    theme="primary"
                    onClick={() => navigate('/subscription')}
                >
                    {t('SUBSCRIPTION.GO_BACK')}
                </Button>
            </>
        </Container>
    );
};

export default SubscriptionPage;
